import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

const ML_SUBSCRIBE_URL = "https://assets.mailerlite.com/jsonp/2628024/forms/198318976576521246/subscribe";

export const NewsletterForm = ({ testidPrefix = "newsletter", compact = false }) => {
  const [form, setForm] = useState({ name: "", email: "" });
  const [state, setState] = useState({ loading: false, done: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, done: false, error: "" });
    try {
      const body = new URLSearchParams();
      body.append("fields[name]", form.name);
      body.append("fields[email]", form.email);
      body.append("ml-submit", "1");
      body.append("anticsrf", "true");
      const res = await fetch(ML_SUBSCRIBE_URL, { method: "POST", body });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.success !== true) throw new Error("ml");
      api.post("/newsletter/record", { email: form.email }).catch(() => {});
      setState({ loading: false, done: true, error: "" });
    } catch {
      setState({ loading: false, done: false, error: "L'inscription n'a pas abouti. Réessaie dans un instant." });
    }
  };

  return (
    <div className={`ml-form-embedContainer ml-subscribe-form ml-subscribe-form-45828122 ${compact ? "ml-compact" : ""}`}>
      <div className="ml-form-embedWrapper embedForm">
        {!state.done ? (
          <div className="ml-form-embedBody ml-form-embedBodyDefault row-form">
            <div className="ml-form-embedContent">
              <h4>La Bascule</h4>
              <p>Ne t'inscris pas si tu veux rester un Freelance en régie</p>
            </div>
            <form className="ml-block-form" onSubmit={submit} data-testid={`${testidPrefix}-form`}>
              <div className="ml-form-formContent">
                <div className="ml-form-fieldRow">
                  <div className="ml-field-group ml-field-name ml-validate-required">
                    <input
                      aria-label="name"
                      aria-required="true"
                      type="text"
                      required
                      className="form-control"
                      name="fields[name]"
                      placeholder="Prénom"
                      autoComplete="given-name"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      data-testid={`${testidPrefix}-name-input`}
                    />
                  </div>
                </div>
                <div className="ml-form-fieldRow ml-last-item">
                  <div className="ml-field-group ml-field-email ml-validate-email ml-validate-required">
                    <input
                      aria-label="email"
                      aria-required="true"
                      type="email"
                      required
                      className="form-control"
                      name="fields[email]"
                      placeholder="Email"
                      autoComplete="email"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      data-testid={`${testidPrefix}-email-input`}
                    />
                  </div>
                </div>
              </div>
              <div className="ml-form-embedSubmit">
                <button type="submit" className="primary" disabled={state.loading} data-testid={`${testidPrefix}-submit-button`}>
                  {state.loading ? <Loader2 className="w-4 h-4 animate-spin inline-block" /> : "Je m'abonne"}
                </button>
              </div>
              {state.error && (
                <p data-testid={`${testidPrefix}-error`} className="mt-3 text-sm text-red-400">{state.error}</p>
              )}
            </form>
          </div>
        ) : (
          <div className="ml-form-successBody row-success">
            <div className="ml-form-successContent" data-testid={`${testidPrefix}-success`}>
              <h4>C'est noté !</h4>
              <p>Vérifie ta boîte mail pour confirmer ton inscription (pense à regarder tes spams).</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
